<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :hide-overlay="$vuetify.breakpoint.xsOnly"
    :max-width="$vuetify.breakpoint.xsOnly ? '' : '1000'"
    :transition="$vuetify.breakpoint.xsOnly ? 'dialog-bottom-transition' : ''"
    persistent
  >
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ $t('tenants.tenant_users') }} {{ currentTenant.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text v-if="loading" style="padding: 45px">
        <hb-loading-indicator align-middle/>
      </v-card-text>

      <v-fade-transition>
        <div v-if="!loading">
          <v-card-text class="pa-0">
            <v-text-field
              v-model="searchPhrase"
              :placeholder="`${$t('user_management.search')}...`"
              class="users-search-input pt-0"
              clearable
              full-width
              hide-details
              single-line
            >
              <v-icon slot="append" style="cursor: pointer">search</v-icon>
            </v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text class="pa-0">
            <v-row class="users-wrapper ma-0" no-gutters>
              <v-col class="users-list app-users" cols="12" order="2" order-sm="1" sm="6">
                <v-list color="transparent">
                  <v-subheader>{{ $t('tenants.all_users_for_app') }}</v-subheader>
                  <template v-if="filteredAllUsers.length > 0">
                    <v-list-item v-for="user in filteredAllUsers" :key="`${user.id}_app`">
                      <v-list-item-action>
                        <v-btn icon @click="addUserToTenant(user)">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ user.email ? user.email : user.subject }}</v-list-item-title>
                        <v-list-item-subtitle v-if="user.firstName && user.lastName"
                        >{{ user.firstName }} {{ user.lastName }}
                        </v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-else>
                    <v-alert :value="true" class="ma-4" dense text type="info">
                      {{ $t('tenants.no_users_in_app') }}
                    </v-alert>
                  </template>
                </v-list>
              </v-col>
              <v-col class="users-list tenant-users" cols="12" order="1" order-sm="2" sm="6">
                <v-list color="transparent">
                  <v-subheader>{{ $t('tenants.tenant_users') }}</v-subheader>
                  <template v-if="loadingTenantUsers">
                    <loading-indicator/>
                  </template>
                  <template v-else-if="filteredTenantUsers.length > 0">
                    <v-list-item v-for="user in filteredTenantUsers" :key="`${user.id}_tenant`">
                      <v-list-item-action v-if="$vuetify.breakpoint.xsOnly">
                        <v-btn icon @click="removeUserFromTenant(user)">
                          <v-icon color="warning">remove_circle_outline</v-icon>
                        </v-btn>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ user.email ? user.email : user.subject }}</v-list-item-title>
                        <v-list-item-subtitle v-if="user.firstName && user.lastName"
                        >{{ user.firstName }} {{ user.lastName }}
                        </v-list-item-subtitle>
                        <v-row>
                          <v-col lg="12" sm="12" xl="12">
                            <div class="d-inline-block">
                              <template v-for="role in userRoles(user)">
                                <v-chip
                                  :key="role"
                                  :color="$randomizeColorFromString(role, 60, 45)"
                                  class="mr-1"
                                  close
                                  outlined
                                  small
                                  @click:close="removeRoleFromUser(user, role)"
                                ><strong>{{ $t('user_management.role.' + role) }}</strong></v-chip
                                >
                              </template>
                            </div>
                            <v-menu bottom right>
                              <template v-slot:activator="{ on }">
                                <v-btn class="ma-0" color="grey lighten-2" icon text v-on="on">
                                  <v-icon v-if="user._loadingRoles" size="22">mdi mdi-loading mdi-spin</v-icon>
                                  <v-icon v-else size="22">add_circle</v-icon>
                                </v-btn>
                              </template>
                              <v-list class="pt-0 pb-0" dense>
                                <v-subheader>{{ $t('user_management.add_role_to_user') }}:</v-subheader>
                                <v-list-item v-for="role in availableRolesForUser(user)" :key="role"
                                             @click="addRoleToUser(user, role)">
                                  <v-list-item-content :style="{ color: $randomizeColorFromString(role, 60, 55) }">
                                    <v-list-item-title class="font-weight-bold">{{
                                        $t('user_management.role.' + role)
                                      }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                        </v-row>


                      </v-list-item-content>
                      <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                        <v-btn v-if="tenantUsers.length >= 2 /* Prevent removing last user from tenant */" icon
                               @click="removeUserFromTenant(user)">
                          <v-icon color="warning">remove_circle_outline</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                  <template v-else>
                    <v-alert :value="true" class="ma-4" dense text type="info">
                      {{ $t('tenants.no_users_in_tenant') }}
                    </v-alert>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-fade-transition>
    </v-card>
  </v-dialog>
</template>

<script>
import adminApi from '../../api/admin';
import tenantApi from "@/api/tenant";
import LoadingIndicator from "@/public/components/LoadingIndicator";
import orderBy from "lodash/orderBy";

export default {
  name: 'UsersDialog',
  components: {LoadingIndicator},
  data() {
    return {
      dialog: false,
      loading: false,
      currentTenant: {},
      allUsers: [],
      tenantUsers: [],
      searchPhrase: '',
      roles: [],
      loadingTenantUsers: false,
    };
  },
  methods: {
    async getRoles() {
      try {
        this.roles = await tenantApi.getRoles();
      } catch (error) {
        this.$handleApiError(error);
      }
    },
    setUserRoleLoading(user, loading) {
      this.$set(this.tenantUsers, this.tenantUsers.findIndex(u => u.id === user.id), {
        ...user,
        _loadingRoles: loading,
      });
    },
    setUserTenantRoleLoading(user, role, loading) {
      try {
        user.tenantRoles.find(t => t.tenant === this.currentTenant.id).roleSet.find(r => r === role)._loading = loading;
      } catch (e) {

      }
    },
    getUserTenantRoles(user) {
      return user.tenantRoles.find(r => r.tenant === this.currentTenant.id)?.roleSet || [];
    },
    userRoles(user) {
      return this.roles.filter(role => this.getUserTenantRoles(user).includes(role));
    },
    availableRolesForUser(user) {
      const availableRoles = this.roles.filter(role => role.startsWith('tenant_') && !this.getUserTenantRoles(user).includes(role));
      return availableRoles;
    },
    toggleUserRole(user, role) {
      if (this.getUserTenantRoles(user).findIndex(r => r === role) > -1) {
        this.removeRoleFromUser(user, role);
      } else {
        this.addRoleToUser(user, role);
      }
    },
    async addRoleToUser(user, role) {
      this.setUserRoleLoading(user, true);
      try {
        const response = await tenantApi.addRole(user.subject, role);
        this.$showSuccessNotification(this.$t('user_management.user_roles_updated'));
      } catch (err) {
        this.$handleApiError(this.$t('user_management.user_roles_update_failed'));
      }
      this.setUserRoleLoading(user, false);
      this.getTenantUsers();
    },
    async removeRoleFromUser(user, role) {
      if (role === 'tenant_admin') {
        const tenantAdmins = this.tenantUsers.filter((u) => u.tenantRoles.some((t) => t.tenant === this.currentTenant.id && t.roleSet.some((e) => e === 'tenant_admin')));
        console.log(tenantAdmins)
        if (tenantAdmins.length <= 1) {
          this.$showErrorNotification(this.$t('user_management.disallow_tenant_admin_removal_if_last_memberships'));
          return;
        }
      }
      this.setUserRoleLoading(user, true);
      try {
        const response = await tenantApi.deleteRole(user.subject, role);
        this.$showSuccessNotification(this.$t('user_management.user_roles_updated'));
      } catch (err) {
        this.$handleApiError(this.$t('user_management.user_roles_update_failed'));
      }
      this.setUserRoleLoading(user, false);
      this.getTenantUsers();

    },
    async open(tenant) {
      this.dialog = true;
      this.currentTenant = Object.assign({}, tenant);
      this.loading = true;
      await this.getTenantUsers();
      await this.getAllUsers();
      tenantApi.setSelectedTenant(this.currentTenant.id);
      this.getRoles();

      this.loading = false;
    },

    async getTenantUsers() {
      this.loadingTenantUsers = true;
      try {
        let users = await adminApi.getTenantUsers(this.currentTenant.id);
        users = orderBy(users, ["email", 'name'], ["asc", 'asc']);
        users.forEach(u => u._loadingRoles = false)

        this.tenantUsers = users;
      } catch (error) {
        this.$handleApiError(error);
      }
      this.loadingTenantUsers = false;
    },
    async getAllUsers() {
      try {
        const allUsers = await adminApi.getAllUsers();
        allUsers.forEach(user => {
          user.isInTenant = this.tenantUsers.findIndex(tu => tu.id === user.id) !== -1;
        });
        this.allUsers = allUsers;
      } catch (error) {
        this.$handleApiError(error);
      }
    },
    async addUserToTenant(user) {
      try {
        await adminApi.addUserToTenant(user.id, this.currentTenant.id);
        user.isInTenant = true;
        //this.tenantUsers.push(user);
        await this.getTenantUsers();
      } catch (error) {
        this.$handleApiError(error);
      }
    },
    async removeUserFromTenant(user) {
      try {
        const userIndex = this.tenantUsers.findIndex(u => u.id === user.id);
        if (userIndex > -1) {
          await adminApi.removeUserFromTenant(user.id, this.currentTenant.id);
          const allUsersUser = this.allUsers.find(u => u.id === user.id);
          allUsersUser.isInTenant = false;
          this.tenantUsers.splice(userIndex, 1);
        }
      } catch (error) {
        this.$handleApiError(error);
      }
    },
    filterUsers(users, filterOutIsInTenant) {
      const filteredUsers = users;

      const searchPhraseLower = this.searchPhrase !== null ? this.searchPhrase.toLowerCase() : '';
      const searchPhraseArray = searchPhraseLower.split(' ');
      return filteredUsers.filter(user => {
        let found = [];
        const lowerSearchedString = (user.email ? user.email.toLowerCase() : '') + (user.subject ? user.subject.toLowerCase() : '');
        searchPhraseArray.forEach(phrase => {
          if (lowerSearchedString.indexOf(phrase) !== -1) {
            found.push(true);
          } else {
            found.push(false);
          }
        });
        if (filterOutIsInTenant && user.isInTenant) found.push(false);
        return found.indexOf(false) === -1;
      });
    },
  },
  computed: {
    filteredAllUsers() {
      return this.filterUsers(this.allUsers, true);
    },
    filteredTenantUsers() {
      return this.filterUsers(this.tenantUsers, false);
    },
  },
  watch: {
    dialog(value) {
      if (!value) {
        tenantApi.setSelectedTenant(this.$tenant);
        this.currentTenant = {};
        this.tenantUsers = [];
        this.allUsers.map(user => (user.isInTenant = false));
        this.searchPhrase = '';
        this.$emit('on-dismiss');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 599px) {
  .app-users {
    height: calc(100vh - 320px);
  }
  .tenant-users {
    height: 200px;
    background-color: rgba(0, 0, 0, 0.05);
  }
  .users-list {
    overflow: auto;
  }
}

@media only screen and (min-width: 600px) {
  .users-wrapper {
    height: 400px;
  }

  .users-list {
    height: 400px;
    overflow: auto;
  }

  .app-users {
    border-right: 1px solid #eeeeee;
  }
}
</style>

<style lang="scss">
.users-search-input {
  .v-input__slot {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
